import { Provider } from 'react-redux';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router';

import store from './redux/store';
import RedirectHandler from './routes/login/redirect-handler';
import Coupons from './routes/coupons';
import ProtectedRoute from './components/protected-route';
import { RetailerDetails } from './routes/inventory/components/retailers/retailer-details';
import { RetailersList } from './routes/inventory/components/retailers/retailers-list';
import B2BRoutes from './components/b2b-routes';

import * as AppRoutes from './routes';

export const App = () => {
	return (
		<Provider store={store}>
			<BrowserRouter>
				<Routes>
					<Route path="/login" element={<AppRoutes.Login />} />
					<Route path="/redirect" element={<RedirectHandler />} />

					<Route element={<ProtectedRoute />}>
						<Route path="/users" element={<AppRoutes.Users />}>
							<Route path="/users/" element={<AppRoutes.UsersPage />} />
							<Route path="/users/:id" element={<AppRoutes.UserDetails />} />
						</Route>
						<Route path="/sessions" element={<AppRoutes.Sessions />}>
							<Route path="" element={<Navigate to="sla" replace />} />
							<Route path="list" element={<AppRoutes.SessionsPage />} />
							<Route path="sla" element={<AppRoutes.SessionsDashboard />} />
							<Route path=":id/*" element={<AppRoutes.SessionDetails />} />
						</Route>

						<Route path="/orders" element={<B2BRoutes />}>
							<Route path="/orders" element={<AppRoutes.Orders />} />
							<Route path="/orders/:id" element={<AppRoutes.OrderDetails />} />
						</Route>
						<Route path="/coupons" element={<B2BRoutes />}>
							<Route path="/coupons" element={<Coupons />} />
						</Route>
						<Route path="/inventory/retailers" element={<B2BRoutes />}>
							<Route path="/inventory/retailers" element={<RetailersList />} />
							<Route path="/inventory/retailers/:id" element={<RetailerDetails />} />
						</Route>
						<Route path="/inspirations" element={<B2BRoutes />}>
							<Route path="/inspirations" element={<AppRoutes.Inspirations />} />
						</Route>
						<Route path="" element={<B2BRoutes />}>
							<Route path="" element={<AppRoutes.Dashboard />} />
						</Route>
					</Route>
				</Routes>
			</BrowserRouter>
		</Provider>
	);
};
